import { createContext, useContext, ReactNode } from 'react';

interface SupervisorModeContextValue {
  isReadOnly: boolean;
}

const SupervisorModeContext = createContext<SupervisorModeContextValue>({ isReadOnly: false });

export const useSupervisorMode = () => useContext(SupervisorModeContext);

export const SupervisorModeProvider = ({
  isReadOnly,
  children,
}: {
  isReadOnly: boolean;
  children: ReactNode;
}) => (
  <SupervisorModeContext.Provider value={{ isReadOnly }}>{children}</SupervisorModeContext.Provider>
);
